/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

export const useAtributMatrix = ({
  actions,
}) => {
  useEffect(() => {
    actions.fetchListAttributesMatrix();
  }, []);
};

export default useAtributMatrix;
